export class Impact {
  question: string;
  text?: string;
  type: number;
  answer: string;

  constructor(question: string, type: number, answer: string, text?: string) {
    this.question = question;
    this.text = text;
    this.type = type;
    this.answer = answer;
  }
}
